module.exports = __webpack_public_path__ + "images/gold-card63cd98cd59f1a51630c5c4651e6b14ec.png";